import { createAction } from 'redux-actions'
import { LOGIN_USER, LOGOUT_USER, SET_HIGH_CONTRAST, LOGIN_USER_ERROR, GET_CONFIG, GET_ZONES, API_ERROR} from '../constants/ActionTypes'
import { loadTranslations } from './RmaActions'
import Odoo from '../utils/Odoo'

export const logUserOut = createAction(LOGOUT_USER)

export function setHighContrast(high_contrast) {
  return dispatch => {
    dispatch({
      type: SET_HIGH_CONTRAST,
      payload: high_contrast
    })
  }
}

export function getZones(){
  return dispatch => {
    let params = {}
    Odoo.login('rma/get_zones', params, false).then(zones => {
      dispatch({
        type: GET_ZONES,
        payload: zones
      })
    }).catch(error => {
      dispatch({
        type: API_ERROR,
        message: error.message
      })
    })
  }
}

export function logUserIn(login, password, rma_zone, rma_zone_password) {
  return dispatch => {
    let params = {login, password, rma_zone, rma_zone_password}
    Odoo.login('rma/login', params).then(session => {
      Odoo.call('rma/get_config', {}, session.token).then(config => {
        dispatch({
          type: GET_CONFIG,
          payload: { ...config }
        })
        dispatch({
          type: LOGIN_USER,
          payload: { ...session }
        })
        dispatch(loadTranslations((session.lang==='pl_PL') ? 'pl-PL' : 'en-US'))
      }).catch(error => {
        dispatch({
          type: API_ERROR,
          message: error.message
        })
      })
    }).catch(error => {
      dispatch({
        type: LOGIN_USER_ERROR,
        message: error.message
      })
    })
  }
}
